// Invite Teammates CTA Sources
export const INVITE_TEAMMATES_SIDEBAR_CALLOUT =
  'Invite Teammates Sidebar Callout';
export const INVITE_TEAMMATES_DROPDOWN_HEADER =
  'Invite Teammates Dropdown Header';
export const APPROACHING_CONTENT_LIMIT_CHIP = 'Approaching Content Limit Chip';
export const APPROACHING_CONTENT_LIMIT_BANNER =
  'Approaching Content Limit Banner';
export const GLOBAL_CONTENT_LIMIT_BANNER = 'Global Content Limit Banner';
